import * as types from '../constants/actionTypes';

const initialState = {
  returnOrders: [],
  currentReturnOrder: null,
  creditNotes: [],
  currentCreditNote: null,
  loading: false,
  actionLoading: false,
  error: null,
};

const replaceReturnOrder = (list, updated) =>
  list.map((r) => (r.id === updated.id ? updated : r));

const replaceCreditNote = (list, updated) =>
  list.map((c) => (c.id === updated.id ? updated : c));

const returnOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Return Orders ─────────────────────────────────────────────────────────
    case types.CREATE_RETURN_ORDER_REQUEST:
      return { ...state, actionLoading: true, error: null };
    case types.CREATE_RETURN_ORDER_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        returnOrders: [action.payload, ...state.returnOrders],
      };
    case types.CREATE_RETURN_ORDER_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    case types.FETCH_RETURN_ORDERS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_RETURN_ORDERS_SUCCESS:
      return { ...state, loading: false, returnOrders: action.payload || [] };
    case types.FETCH_RETURN_ORDERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_RETURN_ORDER_REQUEST:
      return { ...state, loading: true };
    case types.FETCH_RETURN_ORDER_SUCCESS:
      return { ...state, loading: false, currentReturnOrder: action.payload };
    case types.FETCH_RETURN_ORDER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.APPROVE_RETURN_ORDER_REQUEST:
    case types.UPDATE_RETURN_ORDER_STATUS_REQUEST:
      return { ...state, actionLoading: true, error: null };

    case types.APPROVE_RETURN_ORDER_SUCCESS:
    case types.UPDATE_RETURN_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        returnOrders: replaceReturnOrder(state.returnOrders, action.payload),
        currentReturnOrder:
          state.currentReturnOrder?.id === action.payload.id
            ? action.payload
            : state.currentReturnOrder,
      };

    case types.APPROVE_RETURN_ORDER_FAILURE:
    case types.UPDATE_RETURN_ORDER_STATUS_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    // ── Credit Notes ──────────────────────────────────────────────────────────
    case types.CREATE_CREDIT_NOTE_REQUEST:
      return { ...state, actionLoading: true, error: null };
    case types.CREATE_CREDIT_NOTE_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        creditNotes: [action.payload, ...state.creditNotes],
      };
    case types.CREATE_CREDIT_NOTE_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    case types.FETCH_CREDIT_NOTES_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_CREDIT_NOTES_SUCCESS:
      return { ...state, loading: false, creditNotes: action.payload || [] };
    case types.FETCH_CREDIT_NOTES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_CREDIT_NOTE_REQUEST:
      return { ...state, loading: true };
    case types.FETCH_CREDIT_NOTE_SUCCESS:
      return { ...state, loading: false, currentCreditNote: action.payload };
    case types.FETCH_CREDIT_NOTE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.ADJUST_CREDIT_NOTE_REQUEST:
      return { ...state, actionLoading: true, error: null };
    case types.ADJUST_CREDIT_NOTE_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        creditNotes: replaceCreditNote(state.creditNotes, action.payload),
        currentCreditNote:
          state.currentCreditNote?.id === action.payload.id
            ? action.payload
            : state.currentCreditNote,
      };
    case types.ADJUST_CREDIT_NOTE_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    case types.CLEAR_RETURN_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default returnOrderReducer;
